export const currencyConstants = {
    "CAD" : "CAD",
    "DOLLAR" : "$",
    "CANADIAN_DOLLAR" : "C$" 
}